    <footer class="navbar navbar-default navbar-fixed-bottom footer" role="navigation">
        <div class="navbar-inner text-center">
                <div style="padding: 6px">
                    <img src="../../../../../assets/images/sigos.png"
                        style="width: 90px" [alt]="'Sigos'" title="Sigos" />
                </div>
        </div>
    </footer>